import React, { useState } from "react";
import "../../../style/model.css";
import { waitlist } from "../constants/Constants_Functions";
import { landing_status } from "../constants/Constants_Var";

const WaitListForm = ({ isOpen, onClose, name, status }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  if (!isOpen) return null;
  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
          <h2>
            {landing_status.contact === status ? "Contact Us" : "Join Waitlist"}
          </h2>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id={name}
              name={name}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              placeholder="Enter your email"
              className="model-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              placeholder="Write your message here"
            ></textarea>
          </div>
          <button
            className="submit-btn"
            onClick={async () => {
              const action = await waitlist(email, setEmail, status, message);
              if (action) setMessage("");
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default WaitListForm;
